import Seo from "@/components/Seo";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="section" style={{ minHeight: "60vh", display: "grid", placeItems: "center" }}>
      <Seo title="Page not found | Commercial Solar ROI" description="This page moved off-grid. Start from the homepage: commercial solar ROI, bill reviews, calculators and the Solar Black Belt Academy." noindex />
      <div style={{ textAlign: "center" }} data-testid="not-found">
        <span className="eyebrow">LOST THE THREAD?</span>
        <h1 style={{ margin: "14px 0" }}>This page moved off-grid.</h1>
        <p className="muted" style={{ marginBottom: 26 }}>The link may be old. Everything on the site starts from here.</p>
        <Link className="btn" to="/">Back to the homepage <span>↗</span></Link>
      </div>
    </section>
  );
}
